// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card.widget-profile.pat-widget-profile[data-v-a7bd4690]{border:4px solid rgba(0,0,0,.2)}.profile-item[data-v-a7bd4690]{display:inline-block;width:50%}.align-right[data-v-a7bd4690]{text-align:right}.country-code-select[data-v-a7bd4690]{border:1px solid #ced4da;border-radius:4px;font-size:14px;color:#495057;height:32px;width:62px;margin-left:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
